<template>
  <BaseAction class="new-message-action">
    <SecondaryButton
      class="message-button"
      @click.native="onClick"
      :textColor="textColor"
      :color="color || 'primary'"
    >
      <inline-svg
        :src="iconSrc || baseIconSrc"
        width="28"
        height="26"
        :class="{ 'base-icon': !iconSrc }"
      />
      {{ title || "New Message" }}
    </SecondaryButton>
    <slot name="button" />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

export default {
  name: "NewMessageAction",
  props: {
    selectedBookingId: String,
    selectedCandidatesIds: Array,
    textColor: String,
    iconSrc: String,
    title: String,
    color: String
  },
  components: {
    BaseAction,
    SecondaryButton,
    InlineSvg
  },
  data() {
    return {
      baseIconSrc: require("@/assets/svg/navigation-drawer/messages_blue.svg")
    };
  },
  methods: {
    onClick() {
      this.$router.push({
        name: "newConversation",
        params: {
          ...(this.selectedBookingId && {
            selectedBookingId: this.selectedBookingId
          }),
          selectedCandidatesIds: this.selectedCandidatesIds
        }
      });
    }
  }
};
</script>
<style lang="scss">
.new-message-action .message-button svg.base-icon {
  path,
  rect {
    fill: $white;
  }
}
</style>
